import add from "./Add";
import firmware from "./Firmware";
import group from "./Group";
import groupEdit from "./GroupEdit";
import highlight from "./Highlight";
import select from "./Select";
import view from "./view";

export default {
    add,
    firmware,
    group,
    "group-edit": groupEdit,
    select,
    view,
    highlight,
};
